// TODO: rename breadcrumb в nav и туда засунь все что связано с навигацией
export default {
  path: 'instructions',
  meta: {
    layout: 'main',
    breadcrumb: {
      linkTo: 'instructions',
      linkText: 'Инструкции'
    }
  },
  component: () => import('../views/instructions/Index.vue'),
  children: [
    {
      path: '',
      name: 'instructions',
      component: () => import('../views/instructions/Instructions.vue'),
      meta: {
        layout: 'main'
      }
    },
    {
      path: 'category/:instructionsCategoryId',
      component: () => import('../views/instructions/InstructionGroupIndex.vue'),
      props: true,
      meta: {
        layout: 'main',
        paramName: 'instructionsCategoryId',
        breadcrumb: {
          storePath: 'instructions.categories'
        }
      },
      children: [
        {
          path: '',
          name: 'instructionsCategory',
          component: () => import('../views/instructions/Instructions.vue'),
          props: true,
          meta: {
            layout: 'main'
          }
        },
        {
          path: 'instruction/:instructionId',
          name: 'instruction',
          component: () => import('../views/instructions/Instruction.vue'),
          props: true,
          meta: {
            layout: 'main',
            excludeFromMenu: true,
            paramName: 'instructionId',
            breadcrumb: {
              storePath: 'instructions.details'
            }
          }
        }
      ]
    }
  ]
}